import { bigFractionFromNumber } from "@aprao/common/src/math/BigFraction.js";
import { makeAutoObservable } from "mobx";

import { readOnlyRelativesSetFacadeWithAbsolute } from "../RelativesSetFacade.js";
import type { BuildPhaseFacade } from "./BuildPhaseFacade.js";

/**
 * A store for the build phases metrics using read-only relatives.
 *
 * This store is left here so that we are not tempted to use it in the other parts
 * of the app to derive calculation. It proved itself to be generating loops and hard
 * to debug issues.
 */
export class BuildPhaseRelatives {
  constructor(readonly phase: BuildPhaseFacade) {
    makeAutoObservable(this);
  }

  get costTotal() {
    return readOnlyRelativesSetFacadeWithAbsolute(
      {
        relatives: {
          absolute: this.phase.costTotal?.toFraction() ?? null,
          ratioGrossArea: null,
          ratioQuantity: null,
        },
      },
      {
        ratioGrossArea: () =>
          this.phase.grossArea.relativesSet.getRelative("absolute"),
        ratioQuantity: () =>
          this.phase.salesItemsCount == null ?
            null
          : bigFractionFromNumber(this.phase.salesItemsCount),
      },
    );
  }

  get costTotalWithContingency() {
    return readOnlyRelativesSetFacadeWithAbsolute(
      {
        relatives: {
          absolute: this.phase.costTotalWithContingency?.toFraction() ?? null,
          ratioGrossArea: null,
          ratioQuantity: null,
        },
      },
      {
        ratioGrossArea: () =>
          this.phase.grossArea.relativesSet.getRelative("absolute"),
        ratioQuantity: () =>
          this.phase.salesItemsCount == null ?
            null
          : bigFractionFromNumber(this.phase.salesItemsCount),
      },
    );
  }
}
